export class CreatePropertyError extends Error {
}
